import { GatewayApi } from './base';
import {toBase64} from "../common";


class EventImpl {
    constructor(
        readonly source?: string,
        readonly source_file?: string,
        readonly download_end?: string,
        readonly process_time?: string,
        readonly json_output?: string,
        readonly cfg?: string,
        readonly event_log?: string,
        readonly process_log?: string,
        readonly res?: number,
        readonly file_size?: number,
        readonly objectId?: string,
        readonly download_start?: string,
        readonly source_update_time?: string,
        readonly upload_S3_time?: string,
        readonly error_category?: string,
        readonly error_message?: string,
    ) {}
}

export interface Event extends EventImpl { }

export type EventField = keyof Event;
export type EventFilter = {field: EventField | string, operator: string, value: any}[];
export type EventSorting = {field: EventField, operator: string} | undefined;
export const eventFields: EventField[] =
    Object.keys(new EventImpl()) as EventField[];

export class EventsApi extends GatewayApi {
    constructor() {
        super('events');
    }

    index(
        filter?: Record<string, any>,
        page: number = 1,
        page_size: number = 10,
        sort?: EventSorting): Promise<{ items: Event[], count: number }> {
        return this.invoke('index', { filter, page, page_size, sort });
    }

    async filters(): Promise<EventFilter> {
        const schema = await this.invoke('filters');
        return schema?.filters ?? {};
    }

    async removeByIds(objectIds: string | string[]) {
        const res = await this.invoke('removeByIds', {objectIds});
        return res;
    }

    async removeAllWithoutSource() {
        const res = await this.invoke('removeAllWithoutSource');
        return res;
    }

    repeat(
        event: Event,
        clear_cache: String
        ) {
        let { source_file, process_log } = event;
        if (source_file === undefined) {
            const err = "Can't repeat event, source_file is undefined."
            return err;
        }
        let user = ''

        if (this.user) {
            user = this.user.name.join();
        }

        // TODO: make backend return only logical paths instead of full urls with cloudfront domains.
        // let backend decide when to return cloudfront (i.e. if file is big enough for UI to download).
        if (source_file.startsWith('http')) {
            source_file = source_file.split('/').slice(3).join('/');
        }
        this.invoke('repeat', { source_file, user, process_log, clear_cache});
    }

    async create_test_event(file: File, config: string) {
        let author = ''
        let content = (await toBase64(file) as string);
        content = content.slice(content.indexOf('base64') + 6);

        if (this.user) {
            author = this.user.name.join();
        }

        return this.invoke('create_test_event', {data: {name: file.name, content, author}, config});
    }

    async index_date_range(filter: Record<string, any>) {
        return this.invoke('index_date_range', {filter});
    }
}